export default __webpack_public_path__ + "static/media/profile-default.48e19449.svg";